import { useState } from 'react';
import './PropertiesCard.css'
import { downloadFile } from '../../modules/StoresModule/Services/InventoryConfigurationService';



/**
 * 
 * @param {Object} object - expected structure {title: string, subtitle: string, ...[property: string]:string}
 * @param {Object} ignore - array with the property names to be ignored.
 * @param {boolean} singleCard - true: All properties in a single card. false: One card for each porperty
 * @param {boolean} horizontalCard - show a single card with horizontal layout
 * @param {string} className
 * 
 */
export const PropertiesCard = ({ object, ignore, singleCard, horizontalCard, className, horizontalCardProperties }) => {
  const ignoreProperties = [...(ignore ?? []), 'title', 'subtitle'];

   const handleDownload = (name) => {
    downloadFile(name, "parts-certificates")
      .then((response) => {
        const contentType =
          response.headers["content-type"] || "application/octet-stream";
        const disposition = response.headers["content-disposition"];
        let filename = name;
        if (disposition && disposition.includes("filename=")) {
          const matches = disposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (matches?.[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
       
      });
  };
  return (<div className={`properties-card-component${horizontalCardProperties ? ' horizontal-component' : ''}`}>
    {horizontalCard ? <div className='horizontal-card'>
      {(Boolean(object.title) || Boolean(object.subtitle)) &&
        <div className="card-title">
          {Boolean(object.title) && <b>{object.title}</b>}
          {Boolean(object.subtitle) && <span>{object.subtitle}</span>}
        </div>
      }
      {Object.entries(object).filter(([key, _]) => !ignoreProperties.includes(key)).map(([key, value]) => <div key={key} className='vertical-property'>
          <span>{key}</span>
           {key == "Certificate File" ? <a>{value}</a> : <b>{value}</b>}
        </div>
        )}
    </div>
    :<>
      {(Boolean(object.title) || Boolean(object.subtitle)) && <div className="properties-card-header">
        {Boolean(object.title) && <b>{object.title}</b>}
        {Boolean(object.subtitle) && <span>{object.subtitle}</span>}
      </div>}
      <div className={`content ${singleCard ? 'single-card' : ''} ${className}`}>
        {Object.entries(object).filter(([key, _]) => !ignoreProperties.includes(key)).map(([key, value]) => <div key={key} className='property'>
          <span>{key}</span>
          {key == "Certificate File" ? <a onClick={() => handleDownload(value)}>{value}</a> : <b>{value}</b>}
        </div>
        )}

      </div>
    </>}
  </div>);
}